module.exports = __webpack_public_path__ + "static/media/big-lucky-icon-white-bg-green-1024x1024-1024x1024.f4cc4b7f.png";